import { useWebhookListIntegrationWebhookListGetQuery } from '@shared/api';

export const useGetIntegrations = (channelId: number) => {
  const { data, isLoading, isFetching, isError, refetch } =
    useWebhookListIntegrationWebhookListGetQuery(
      {
        channelId,
      },
      {
        skip: !channelId,
      },
    );

  const isEmpty = !data || data.length === 0;
  const count = data?.length ?? 0;

  return {
    integrations: data,
    count,
    isEmpty,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};
